function removeFormatting(value, regex = /\D/g) {
  if (!value) return value;
  return value.replace(regex, '');
}

export default removeFormatting;
